// The visitor's live-chat choice. Browser storage can be blocked, so every access is guarded;
// without storage the choice simply lasts for the current page view.
import { CONSENT_KEY } from "../config/salesiq";

export const RESET_EVENT = "dopove:chat-consent-reset";

export const readConsent = () => {
  try {
    const value = window.localStorage.getItem(CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
};

export const writeConsent = (value) => {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage blocked: keep the choice in memory only */
  }
};

// Forget the choice and ask again. A widget that is already loaded cannot be unloaded, so reload the page.
export const resetConsent = () => {
  const widgetLoaded = Boolean(document.getElementById("zsiqscript"));
  try {
    window.localStorage.removeItem(CONSENT_KEY);
  } catch {
    /* storage blocked */
  }
  if (widgetLoaded) {
    window.location.reload();
  } else {
    window.dispatchEvent(new Event(RESET_EVENT));
  }
};
